import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * /auth/sso/not-provisioned — D-SM-14 copy.
 * Shown when JIT provisioning is disabled and the user has no pre-provisioned account.
 * Directs the user to contact their administrator (tenant CISO escalation contact).
 */
export function SsoNotProvisionedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-accent-cyan/10">
            <Lock className="h-7 w-7 text-accent-cyan" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-text-primary">Access not provisioned</h1>
        <p className="mt-3 text-sm text-text-secondary">
          Your account has not been provisioned in this organisation. Please contact your
          administrator to request access.
        </p>
        <p className="mt-4 text-xs text-text-secondary">
          If you believe this is an error, have your administrator check the SSO configuration
          and user provisioning settings in VeriGRC.
        </p>
        <div className="mt-8">
          <Button variant="outline" asChild>
            <a href="/login">Back to sign in</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
